import usePrevious from '@nkr/services/use-previous';
import { Utility } from '@nkr/services/utility';
import { FormEvent, useEffect, useState } from 'react';
import { Alert, Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    currentUserEmail: string,
    onSend: (recipientList: string[]) => void,
    onCancel: () => void
}

const TestRecipientsModal = (props: IProps) => {
    const [recipientList, setRecipientList] = useState('');
    const [validEmails, setValidEmails] = useState(true);
    const [dirty, setDirty] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setRecipientList(props.currentUserEmail);
        }
    }, [props.show]);

    const handleSend = () => {
        let list = recipientList.split('\n');

        let validEmails = list.filter(email => Utility.isValidEmail(email) == false).length == 0;

        setValidEmails(validEmails);
        setDirty(true);

        if (validEmails == true) {
            props.onSend(recipientList.split('\n'));
        }
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Specify Recipients for Test Email</Modal.Header>
            <Modal.Body>
                {dirty && validEmails == false && (
                    <Alert bsStyle='danger' bsSize='sm'>
                        One or more of the specified email addresses is invalid...
                    </Alert>
                )}

                <FormGroup style={{ marginBottom: 0 }} validationState={dirty && validEmails == false ? 'error' : null}>
                    <ControlLabel>Enter each email address on a separate line...</ControlLabel>
                    <FormControl
                        componentClass='textarea'
                        style={{ resize: 'none', height: 100 }}
                        value={recipientList}
                        onChange={(e: FormEvent<FormControl & HTMLTextAreaElement>) => setRecipientList(e.currentTarget.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSend}>Send Test Email</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TestRecipientsModal;